function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var plugin = require('tailwindcss/plugin');

var merge = require('lodash/merge');

var castArray = require('lodash/castArray');

var styles = require('./styles');

var computed = {// Reserved for future "magic properties", for example:
  // bulletColor: (color) => ({ 'ul > li::before': { backgroundColor: color } }),
};

function configToCss(config) {
  return merge.apply(void 0, _toConsumableArray(Object.keys(config).filter(function (key) {
    return computed[key];
  }).map(function (key) {
    return computed[key](config[key]);
  })).concat(_toConsumableArray(castArray(config.css || {}))));
}

module.exports = plugin.withOptions(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? ['sm', 'lg', 'xl', '2xl'] : _ref$modifiers;

  return function (_ref2) {
    var addComponents = _ref2.addComponents,
        theme = _ref2.theme,
        variants = _ref2.variants;
    var config = theme('typography', {});
    addComponents([{
      '.prose': merge.apply(void 0, _toConsumableArray(castArray(styles["default"].css)).concat([configToCss(config["default"] || {})]))
    }].concat(_toConsumableArray(modifiers.map(function (modifier) {
      return _defineProperty({}, ".prose-".concat(modifier), merge.apply(void 0, _toConsumableArray(castArray(styles[modifier].css)).concat([configToCss(config[modifier] || {})])));
    })), _toConsumableArray(Object.keys(config).filter(function (key) {
      return !['default'].concat(_toConsumableArray(modifiers)).includes(key);
    }).map(function (modifier) {
      return _defineProperty({}, ".prose-".concat(modifier), configToCss(config[modifier]));
    }))), variants('typography'));
  };
}, function () {
  return {
    variants: {
      typography: ['responsive']
    }
  };
});